import { get } from "../../service/api";

const GetSettleUniqueAccounts = async (merchantId, merchantSettleId) => {
    try {
        const response = await get(`/merchant/${merchantId}/merchantSettle/${merchantSettleId}/uniqueAccounts`);
        return response;
    } catch (error) {
        console.error('Error GetSettleUniqueAccounts:', error);
        throw error;
    }
};

export default GetSettleUniqueAccounts;
